<div class="bootstrap" appIntersectionObserver (visible)="onVisible()">
  <div class="header">
    <div class="header__title">
      <label>Best Fit Cover Calculator</label>
      <p>Need assistance? Call us <a href="tel:+443300100210">0330 010 0210</a> </p>
    </div>
  </div>

  <form name="questionForm">

    <div class="wrapper apg-panel" *ngIf="questionnaire">
      <div class="card">
        <div class="quick-quote__footer">
          <ng-container [ngSwitch]="questionnaire.currentPage.type">
            <app-cover-questions *ngSwitchDefault [page]="questionnaire.currentPage" [showBackButton]="!quickQuoteUrl"
                                 (back)="back.emit($event)">
            </app-cover-questions>

            <!--<app-cover-confirm *ngSwitchCase="'Confirm'" [questionnaire]="questionnaire"></app-cover-confirm>-->

            <app-cover-results *ngSwitchCase="'Results'" [questionnaire]="questionnaire" (next)="proceed($event)">
            </app-cover-results>
          </ng-container>
        </div>

        <div class="quick-quote__footer" *ngIf="questionnaire.initialScreen">
          <app-apg-quick-quote-home [questionnaire]="questionnaire"></app-apg-quick-quote-home>
        </div>
      </div>
    </div>

  </form>
</div>